import { useEffect, useState, MouseEvent } from 'react';
import GridComponent from '../../../component/grid/GridComponent.component';
import Table from '../../../component/table/Table.component';
import { useSnackbar } from '../../../context/Snackbar';
import { Pagination } from '../../../component/table/interfaces/Pagination';
import { INITIAL_PAGINATION } from '../../../component/table/component/pagination/utils/Pagination';
import {
  Action,
  ACTION_EDIT_SUBMIT,
  ACTION_DELETE,
  ACTION_EDIT,
} from '../../../component/table/interfaces/TableInterface';
import useModal from '../../../hooks/useModal';
import Modal from '../../../component/modal/Modal.component';
import ModalDelete from '../../../component/modal/ModalDelete.component';
import { useStore } from '../../../context/Store';
import { Flag } from './interfaces/Flag';
import ButtonFormFullWithLoading from '../../../component/buttton/ButtonFormFullWithLoading.component';
import { INITIAL_VALUES } from './utils/INITIAL_VALUES';
import Form from './form/Form.component';
import { getFlag, postFlag, putFlag, deleteFlag } from './Flag.service';
import { HEAD_CELL } from './utils/HEAD_CELL';
import { compare } from '../../../utils/order/compare';
import { formatTelephone } from '../../../utils/format/FormatTelefone';

const FlagComponent = () => {
  const { setSnackbar } = useSnackbar();
  const { getFlags } = useStore();
  const [request, setRequest] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [flagState, setFlagState] = useState<Flag[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);
  const [open, addModal] = useModal();
  const [openEdit, addModalEdit] = useModal();
  const [editData, setEditData] = useState<Flag>();

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPagination({ ...pagination, page: newPage + 1 });
  };

  const handleRequestSort = (_event: MouseEvent<unknown>, property: string) => {
    const isAsc = pagination.sort === property && pagination.order === 1;
    setPagination({ ...pagination, sort: property, order: isAsc ? -1 : 1 });
  };

  const handleClickAction = (action: Action, flagObj: Flag) => {
    if (action === ACTION_EDIT_SUBMIT) {
      return registerFlag(flagObj);
    }

    if (action === ACTION_EDIT) {
      setEditData(flagObj);
      return addModalEdit(flagObj.id);
    }

    if (action === ACTION_DELETE) {
      return addModal(flagObj.id);
    }
  };

  const getData = async () => {
    setRequest(true);
    await getFlag({ page: pagination.page })
      .then((response) => {
        if (response.data.data) {
          let data: Flag[] = [];

          response.data.data.forEach((row: Flag) => {
            data.push({
              ...row,
              directorAd: row.directorAd ? row.directorAd.toUpperCase() : '',
              directorPhone: row.directorPhone ? formatTelephone(row.directorPhone) : '',
            });
          });

          setFlagState(data);
          setTotal(response.data.total);
        }
        setRequest(false);
      })
      .catch((err) => {
        setRequest(false);
        setSnackbar({ msg: `Erro ao coletar novos dados`, type: 'error' });
      });
  };

  useEffect(() => {
    getData();
  }, [pagination]);

  const registerFlag = async (flagObj: Flag) => {
    try {
      setSaving(true);
      await (flagObj.id ? putFlag(flagObj) : postFlag(flagObj));
      setSnackbar({
        msg: `Bandeira foi ${flagObj.id ? 'atualizada' : 'cadastrada'} com sucesso!`,
        type: 'success',
      });
      addModal(false);
      addModalEdit(false);
      setSaving(false);
      getData();
      getFlags();
    } catch (error) {
      console.log('Erro ao submeter bandeira!', error);
      setSnackbar({
        msg: `Erro ao ${flagObj.id ? 'atualizar' : 'cadastrar'} bandeira!`,
        type: 'error',
      });
      setSaving(false);
    }
  };

  const handleClickDelete = async () => {
    setRequest(true);
    await deleteFlag(Number(open))
      .then((res) => {
        setSnackbar({ msg: 'Bandeira excluída com sucesso!', type: 'success' });
        getData();
        getFlags();
      })
      .catch((error) => {
        console.log('Erro ao excluir bandeira!', error);
        setRequest(false);
        setSnackbar({ msg: 'Erro ao excluir bandeira!', type: 'error' });
      })
      .finally(function () {
        addModal(undefined);
      });
  };

  useEffect(() => {
    setSaving(false);
  }, [openEdit]);

  return (
    <>
      <GridComponent justify='flex-end' alignItems='flex-end'>
        <Modal title='Criar bandeira' open={open === true} handleClick={() => addModal(!open)}>
          <Form initialValues={INITIAL_VALUES} handleSubmitForm={registerFlag}>
            <ButtonFormFullWithLoading
              disabled={saving ? true : false}
              onClick={() => addModal(false)}
              saving={saving}
            />
          </Form>
        </Modal>
      </GridComponent>

      <Modal open={!!openEdit} handleClick={() => addModalEdit(!openEdit)}>
        <Form initialValues={editData || INITIAL_VALUES} handleSubmitForm={registerFlag}>
          <ButtonFormFullWithLoading
            disabled={saving ? true : false}
            onClick={() => addModalEdit(false)}
            saving={saving}
          />
        </Form>
      </Modal>

      <ModalDelete
        open={!!open && open !== true}
        handleClick={() => addModal(undefined)}
        onClickSubmit={handleClickDelete}
        title='Confirma a exclusão dessa bandeira?'
      />
      <br />
      <br />
      <Table
        request={request}
        data={flagState.sort((a: any, b: any) =>
          compare(a, b, pagination.sort || 'id', pagination.order)
        )}
        size={total}
        headCells={HEAD_CELL}
        page={pagination.page}
        onChangePage={handleChangePage}
        noActionView
        handleClickAction={handleClickAction}
        order={pagination.order === 1 ? 'asc' : 'desc'}
        orderBy={pagination.sort}
        onRequestSort={handleRequestSort}
      />
    </>
  );
};

export default FlagComponent;
